import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Alert } from '@mui/material';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import HomeIcon from '@mui/icons-material/Home';
import Button from './UIKit/Button';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        bgcolor: 'background.default',
      }}
    >
      <Box
        sx={{
          maxWidth: 550,
          width: '100%',
          p: 4,
          borderRadius: 3,
          bgcolor: 'background.paper',
          boxShadow: 3,
        }}
      >
        {/* Icon */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 3,
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: '50%',
              bgcolor: 'error.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: 3,
            }}
          >
            <SearchOffIcon sx={{ fontSize: 40, color: 'common.white' }} />
          </Box>
        </Box>

        {/* Title */}
        <Typography
          variant="h5"
          align="center"
          sx={{
            fontWeight: 700,
            mb: 2,
            color: 'text.primary',
          }}
        >
          {t('not_found_title', '404 - Page Not Found')}
        </Typography>

        {/* Message */}
        <Alert
          severity="error"
          sx={{
            mb: 3,
            borderRadius: 2,
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            {t('not_found_message', 'The page you are looking for does not exist or has been moved.')}
          </Typography>
        </Alert>

        {/* Instructions */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 2,
            p: 2,
            mb: 3,
            borderRadius: 2,
            bgcolor: 'action.hover',
            border: 1,
            borderColor: 'divider',
          }}
        >
          <HomeIcon sx={{ color: 'primary.main', mt: 0.5 }} />
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
            {t('not_found_instructions', 'You can return to the home page or use the navigation menu to find what you need.')}
          </Typography>
        </Box>

        {/* Button */}
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => navigate('/', { replace: true })}
          sx={{ py: 1.5 }}
        >
          {t('back_to_home', 'Back to Home')}
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;
